import React, { useMemo } from "react";

import Select, { LabeledValue, SelectProps } from "antd/es/select";
import { defineMessages, useIntl } from "react-intl";

import { DealsGroupByType } from "@app/scene/home/enum/DealsGroupByType";

const messages = defineMessages<DealsGroupByType>({
  [DealsGroupByType.FUNNEL]: {
    id: "home.cards.engagement.filterTypeSelect.byFunnel",
    defaultMessage: "By funnel",
    description: "Engagement Card Filter Type Select by funnel option",
  },
  [DealsGroupByType.TEAM]: {
    id: "home.cards.engagement.filterTypeSelect.byTeam",
    defaultMessage: "By team",
    description: "Engagement Card Filter Type Select by team option",
  },
  [DealsGroupByType.USER]: {
    id: "home.cards.engagement.filterTypeSelect.byUser",
    defaultMessage: "By user",
    description: "Engagement Card Filter Type Select by user option",
  },
});

type Props = {
  hasTeamAccess?: boolean;
} & Omit<SelectProps<DealsGroupByType>, "options">;

const FilterTypeSelect: React.FC<Props> = ({ hasTeamAccess, ...props }) => {
  const intl = useIntl();

  const filterTypeOptions = useMemo<LabeledValue[]>(() => {
    return Object.values<DealsGroupByType>(DealsGroupByType)
      .filter(
        (value) => ![DealsGroupByType.TEAM, DealsGroupByType.USER].includes(value) || hasTeamAccess
      )
      .map<LabeledValue>((value) => ({
        label: intl.formatMessage(messages[value]),
        value,
      }));
  }, [intl, hasTeamAccess]);

  return (
    <Select<DealsGroupByType>
      dropdownMatchSelectWidth={false}
      options={filterTypeOptions}
      {...props}
    />
  );
};

export default FilterTypeSelect;
